/* Action Types */
export const LOAD_CATALOG_AD_FAIL = 'la/domain/catalogAds/LOAD_FAIL';
export const LOAD_CATALOG_AD_REQUEST = 'la/domain/catalogAds/LOAD_REQUEST';
export const LOAD_CATALOG_AD_SUCCESS = 'la/domain/catalogAds/LOAD_SUCCESS';
